var React = require('react');

function Bath (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.625 7.5a6.25 6.25 0 1 1 12.25 0H10.5V15h-5V7.5h.125zM3 17.5h47.5a2.5 2.5 0 1 1 0 5H3a2.5 2.5 0 1 1 0-5zM3 25h47.5v2.5A7.5 7.5 0 0 1 43 35H10.5A7.5 7.5 0 0 1 3 27.5V25z","fill":"currentColor","fillRule":"nonzero","fillOpacity":"1"}));
}

Bath.defaultProps = {"width":"53","height":"35"};

module.exports = Bath;

Bath.default = Bath;
